import React, { Fragment } from 'react';

import { IServerOrder } from '@rbi-ctg/menu';
import { BottomSheet } from 'components/bottom-sheet';
import Currency from 'components/currency';
import { CenteredRowContainer } from 'components/layout/centered-row-container';
import { t } from 'state/intl/translations';

import { Container, Total, TotalLabelTitle, TotalsRow } from './modal-order-details.styled';
import { OrderItem } from './order-item';
import { OrderPricesDetails } from './order-prices-details';
import { OrderRewardDetails } from './order-reward-details';

type ModalOrderDetailsProps = {
  showModal: boolean;
  onCloseModal: React.Dispatch<React.SetStateAction<void>>;
  serverOrder: IServerOrder;
};

const ModalOrderDetails = ({ showModal, onCloseModal, serverOrder }: ModalOrderDetailsProps) => {
  const { cart, loyaltyTransaction } = serverOrder;

  return (
    <BottomSheet onOpenEventMessage="View Order Details" isOpen={showModal} onClose={onCloseModal}>
      <Container>
        <CenteredRowContainer>
          {cart.cartEntries.map(entry => (
            <Fragment key={entry.lineId}>
              <OrderItem cartEntry={entry} />
            </Fragment>
          ))}
          <OrderPricesDetails serverOrder={serverOrder} />
          {loyaltyTransaction && <OrderRewardDetails loyaltyTransaction={loyaltyTransaction} />}
          <TotalsRow>
            <TotalLabelTitle>{t('total')}</TotalLabelTitle>
            <Total fontSize="md">
              <Currency isBold amount={cart.totalCents} />
            </Total>
          </TotalsRow>
        </CenteredRowContainer>
      </Container>
    </BottomSheet>
  );
};

export default ModalOrderDetails;
